import { render, staticRenderFns } from "./wallet-box1.vue?vue&type=template&id=1c74738d&scoped=true&"
import script from "./wallet-box1.vue?vue&type=script&lang=js&"
export * from "./wallet-box1.vue?vue&type=script&lang=js&"
import style0 from "./wallet-box1.vue?vue&type=style&index=0&id=1c74738d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74738d",
  null
  
)

export default component.exports